import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";
import { getContentByLocale } from "../../content";
import "./Footer.css";

type FooterProps = {
  text: string;
};

export function Footer({ text }: FooterProps) {
  const { locale } = useI18n();
  const content = getContentByLocale(locale);

  return (
    <footer className="footer">
      <div>{text}</div>
      <div style={{ marginTop: "12px" }}>
        <Link to="/privacidade" className="footer-link">
          {content.privacy.title}
        </Link>
      </div>
    </footer>
  );
}
